// extracted by mini-css-extract-plugin
export default {"container":"loading-container_container__16M68"};